module.exports = __webpack_public_path__ + "img/icon_1226.b035dd25.svg";